<template>
    <div class="fordable">
        <div class="sch_condition_wrap _right">
            <button type="button" class="table_btn _blue" @click="isEdit(false, 0)">팝업추가</button>
        </div>
        <div class="common_table custom_scroll">
            <table>
                <colgroup>
                    <col style="width: 70px" />
                    <col />
                    <col style="width: 220px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>번호</th>
                        <th>제목</th>
                        <th>노출기간</th>
                        <th>이미지</th>
                        <th>링크연결</th>
                        <th>메인노출</th>
                        <th>수정</th>
                        <th>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="bannerPopupState.list">
                        <tr v-for="(item, idx) in bannerPopupState.list" :key="idx">
                            <td class="list_num">{{ idx + 1 }}</td>
                            <td>{{ item.title }}</td>
                            <td>
                                {{ CommonUtils.dateFormat(item.startDate, ".", false) + " ~ " + CommonUtils.dateFormat(item.endDate, ".", false) }}
                            </td>
                            <td class="cnt">
                                <button type="button" class="tb_img img_wrap" @click="viewImage(item.file)" v-if="item.file">
                                    <img :src="item.file" alt="" />
                                </button>
                            </td>
                            <td class="cnt">
                                <a :href="item.link" class="link_btn" target="_blank"><img src="img/link_icon.png" alt="" /></a>
                            </td>
                            <td class="cnt checkbox_wrap _plus">
                                <label :for="'plus_1' + idx">
                                    <input
                                        :id="'plus_1' + idx"
                                        type="checkbox"
                                        :checked="item.isShow === 1"
                                        @click="
                                            item.isShow === 1 ? (item.isShow = 0) : (item.isShow = 1);
                                            update(item);
                                        "
                                    />
                                    <em></em>
                                </label>
                            </td>
                            <td class="cnt"><button type="button" class="table_btn _blue" @click="isEdit(true, item)">수정</button></td>
                            <td class="cnt"><button type="button" class="table_btn _gray" @click="isDelete(item.idx)">삭제</button></td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="8"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <PopBannerModal
        v-if="state.isPopupShowModal"
        :isEdit="state.isEdit"
        :data="state.bannerPopupInfo"
        @close="closeModalForPopup"
        @add="add"
        @modify="modify"
    ></PopBannerModal>
</template>

<script lang="ts" config>
    import { reactive, apiService, onMounted, router, ModalDefault, types, getMessageByCode, CommonUtils, PopBannerModal } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            ModalDefault,
            PopBannerModal,
        },
        setup() {
            const state = reactive({
                isShowModal: false as boolean,
                isPopupShowModal: false as boolean,

                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                bannerInfo: {},
                bannerPopupInfo: {},
                deleteIdxForBanner: 0 as number,
                isEdit: false as boolean,
            });

            const bannerPopupState = reactive({
                list: [] as Array<any>,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
            });

            const closeModal = () => {
                state.isShowModal = false;
            };
            const closeModalForPopup = () => {
                state.bannerPopupInfo = {};
                state.isPopupShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove(state.deleteIdxForBanner);
                }
            };

            const viewImage = async (param: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const getList = async () => {
                const res = await apiService.bannerPopup.list();
                if (res.returnCode === 0) {
                    bannerPopupState.list = res.data;
                } else {
                    console.error(res.description);
                    bannerPopupState.list = [];
                }
            };

            const add = async (param: types.ReqBannerPopup) => {
                if (!param.title) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "제목을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!param.startDate || !param.endDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 설정해주세요.";
                    state.isShowModal = true;
                } else if (param.startDate > param.endDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 확인해주세요.";
                    state.isShowModal = true;
                } else if (!param.file) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "이미지 파일을 첨부해주세요.";
                    state.isShowModal = true;
                } else if (!param.link) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "링크를 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    const res = await apiService.bannerPopup.add(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                        state.isPopupShowModal = false;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                    getList();
                }
            };

            const modify = async (param: types.ReqBannerPopupForModify) => {
                if (!param.title) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "제목을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!param.startDate || !param.endDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 설정해주세요.";
                    state.isShowModal = true;
                } else if (param.startDate > param.endDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 확인해주세요.";
                    state.isShowModal = true;
                } else if (!param.link) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "링크를 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    const res = await apiService.bannerPopup.modify(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                        state.isPopupShowModal = false;
                        getList();
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const update = async (item: any) => {
                const param: types.ReqBannerPopupForModify = {
                    idx: item.idx,
                    title: item.title,
                    startDate: null,
                    endDate: null,
                    isSettingClose: item.isSettingClose,
                    location: item.location,
                    link: item.link,
                    isShow: item.isShow,
                    file: null,
                };
                const res = await apiService.bannerPopup.modify(param);
                if (res.returnCode === 0) {
                    getList();
                } else {
                    console.error(res.description);
                }
            };

            const isDelete = async (idx: number) => {
                state.deleteIdxForBanner = idx;

                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
            };

            const remove = async (idx: number) => {
                const res = await apiService.bannerPopup.remove(idx);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;
                    state.deleteIdxForBanner = 0;
                    getList();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const isEdit = async (isEdit: boolean, item: any) => {
                state.isEdit = isEdit;
                // 수정
                if (isEdit) {
                    state.bannerPopupInfo = item;
                }
                state.isPopupShowModal = true;
            };

            return {
                state,
                bannerPopupState,

                router,
                closeModal,
                callBackModal,
                imgError,
                types,
                viewImage,
                CommonUtils,
                update,
                isEdit,
                isDelete,
                closeModalForPopup,
                add,
                modify,
            };
        },
    };
</script>
<!-- <style scoped>
    .file_wrap {
        display: flex;
        gap: 10px;
        align-items: flex-start;
    }
</style> -->
